import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { MobCorpse } from "./mobCorpse";

export class RobotCorpse extends MobCorpse {
	static key = "RobotCorpse";
	constructor(xy: XY) {
		super(xy);
	}

	override getRepairableMobKey(): string | null {
		return "Robot";
	}

	static deserialize(data: any): RobotCorpse {
		const c = new RobotCorpse(deserializeXY(data.xy));
		c.restoreBaseFields(data);
		return c;
	}
}
